import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import cy from "./cy/translations.json";
import en from "./en/translations.json";

const documentLanguage = document.documentElement.lang;

i18next
	.use(initReactI18next)

	// init i18next
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		lng:
			(new URLSearchParams(window.location.search).get("lang") as
				| "en"
				| "cy") ??
			documentLanguage ??
			"en",
		fallbackLng: "en",
		supportedLngs: ["en", "cy"],
		debug: import.meta.env.DEV,
		interpolation: {
			escapeValue: false,
		},
		resources: {
			en,
			cy,
		},
	});
